var productName = 'scheduler';import InstancePlugin from '../../Common/mixin/InstancePlugin.js';
import GridFeatureManager from '../feature/GridFeatureManager.js';

/**
 * @module Grid/feature/Stripe
 */

/**
 * Stripes rows, by adding even (b-even) or odd (b-odd) css classes to row elements.
 *
 * This feature is <strong>disabled</strong> by default.
 *
 * @extends Common/mixin/InstancePlugin
 *
 * @example
 * let grid = new Grid({
 *   features: {
 *     stripe: true
 *   }
 * });
 *
 * @demo columns
 * @classtype stripe
 * @externalexample feature/Stripe.js
 */
export default class Stripe extends InstancePlugin {
    construct(grid, config) {
        this.grid = grid;

        super.construct(grid, config);

        grid.rowManager.on({
            renderrow : this.onRenderRow,
            thisObj   : this
        });
    }

    /**
     * Applies even/odd CSS when row is rendered
     * @param {Grid.row.Row} rowModel
     * @private
     */
    onRenderRow({ row }) {
        row.addCls(row.dataIndex % 2 === 0 ? 'b-even' : 'b-odd');
    }
}

Stripe._$name = 'Stripe'; GridFeatureManager.registerFeature(Stripe);
